import { getApiService } from "../services/ApiService";
import { encryptData } from "../utils/cryptoEncryptApiData";
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';
import { GetPayLoad } from "../services/PayLoadStorage";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const headers = {
    "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
    "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
};

const setLoginFromFlag = async (stringValue) => {
    const region = Cookies.get('region');
    console.log('Region for loginFrom API:', region);
    // Encrypt the string value
    const encryptedData = await encryptData(stringValue);
    const targetUrl = process.env.REACT_APP_API_SET_LOGIN_FROM_EDNPOINT;
    getApiService(baseUrl, targetUrl, { loginFrom: encryptedData, region: region }, headers)
    .then((response) => {
        console.log('setLoginFromFlag response:', response);
        // Handle response if needed
    })
    .catch(error => {
        console.error('Error setting login from flag:', error);
    });
}

const getLoginFromFlag = async (parsedData) => {
   
    let carrierCode = parsedData?.carrier_code.toLowerCase() || null;
    if(carrierCode === 'j1'){
        carrierCode = 'cg'; // J1 maps to CG
    }
    // Retrieve userID from authID cookie if available
    let userID = null;
    if (!!Cookies.get('authID')) {
        const datakey = Cookies.get('authID');
        const loggedId = datakey ? JSON.parse(atob(datakey)) : null;
        userID = loggedId?.loggedId;
    }

    //format date m/d/y
    let dob = parsedData?.dob || null;
    if(dob){
        const dateObj = new Date(dob);
        const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are zero-based, pad with zero
        const day = String(dateObj.getDate()).padStart(2, '0');
        const year = dateObj.getFullYear();
        dob = month + '/' + day + '/' + year;
    }

    const stringValue = [
        parsedData?.member_profile_id || null,
        parsedData?.SSN || null,
        dob || null,
        parsedData?.zip_code || null,
        carrierCode || null,
        userID || null
    ].filter(val => val !== null && val !== '' && val !== undefined).join('|') || null;

    // Encrypt the string value
    const encryptedData = await encryptData(stringValue);

    try {
        const targetUrl = process.env.REACT_APP_API_GET_LOGIN_FROM_EDNPOINT;
        const response = await getApiService(baseUrl, targetUrl, { loginFrom: encryptedData }, headers);
        const resData = response?.data;
        if(resData?.status === 'SUCCESS'){
            return {
                loginFrom: resData?.loginFrom || false,
                region: resData?.region || false
            };
        }
    } catch(error) {
        console.error('Error getting login from flag:', error);
    }

    return { loginFrom: false, region: false };
}

// Set ConnectiCare carrier flag in cookies
const setConnectiCareCarrier = () => {

    const memberData = GetPayLoad('PayLoad');
    let carrierCode = memberData?.owning_carrier.toUpperCase() || null;
    let stateCode = memberData?.state || null;
    let resultValue = carrierCode+stateCode;
    let isConnectiCareCarrier = false;
    let connectiCareCarrier = null;
    
    if(resultValue === process.env.REACT_APP_CONNECTICARE_CARRIER_CODE){
        isConnectiCareCarrier = true;
        connectiCareCarrier = process.env.REACT_APP_CONNECTICARE_CARRIER_CODE;
    }
    Cookies.set('isConnectiCareCarrier', isConnectiCareCarrier, getCookieOptions());
    
    if(isConnectiCareCarrier){
        Cookies.set('connectiCareCarrier', connectiCareCarrier, getCookieOptions());
    }

}

export { setLoginFromFlag, getLoginFromFlag, setConnectiCareCarrier };